import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppLogo = _resolveComponent("AppLogo")!
  const _component_OTPLoginForm = _resolveComponent("OTPLoginForm")!
  const _component_LoginForm = _resolveComponent("LoginForm")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_AppLogo, { variant: "prelogin" }),
    (_ctx.otp_login)
      ? (_openBlock(), _createBlock(_component_OTPLoginForm, { key: 0 }))
      : (_openBlock(), _createBlock(_component_LoginForm, { key: 1 }))
  ]))
}